import React, { useState, useEffect } from 'react';

import useMediaQuery from '@mui/material/useMediaQuery';
import { Avatar, Box, Stack, Typography, Tooltip } from '@mui/material';
import MoreVertIcon from '@mui/icons-material/MoreVert';

import IconButton from '@components/IconButton';

import { useUserPilot } from '@common/hooks/use-userpilot';
import { useGetUserInfo } from '@common/hooks/use-get-user-info';
import AppSwitcherMenu, { getIconPath } from './app-switcher-menu';
import UserMenu from './user-menu';

const UtilityBar = ({
  applicationName,
  PreMenuSlot,
  secondaryUserInfo,
  UtilityHeaderHelpMenu
}) => {
  const isSmall = useMediaQuery(theme => theme.breakpoints.down('md'));

  const [userMenuAnchorEl, setUserMenuAnchorEl] = useState(null);
  const [appSwitcherAnchorEl, setAppSwitcherAnchorEl] = useState(null);

  const { currentUserId, displayName, firstLast, licensedApplications, username } =
    useGetUserInfo();

  const updateUserPilot = useUserPilot();
  useEffect(() => {
    updateUserPilot({
      name: displayName
    });
  }, [updateUserPilot, displayName]);

  const openUserMenu = event => {
    setUserMenuAnchorEl(event.currentTarget);
  };

  const openAppSwitcherMenu = event => {
    setAppSwitcherAnchorEl(event.currentTarget);
  };

  const closeUserMenu = () => {
    setUserMenuAnchorEl(null);
  };

  const closeAppSwitcherMenu = () => {
    setAppSwitcherAnchorEl(null);
  };

  return (
    <>
      {PreMenuSlot && <PreMenuSlot />}
      <UserMenu
        anchorEl={userMenuAnchorEl}
        closeMenu={closeUserMenu}
        isSmall={isSmall}
        primaryListItemText={firstLast}
        secondaryListItemText={secondaryUserInfo || username}
      />
      <AppSwitcherMenu
        anchorEl={appSwitcherAnchorEl}
        applicationName={applicationName}
        closeMenu={closeAppSwitcherMenu}
        licensedApplications={licensedApplications}
      />
      {!isSmall ? (
        <Box sx={{ minWidth: 150, ml: 1 }}>
          <Tooltip title="Switch Applications">
            <IconButton aria-label="apps" onClick={openAppSwitcherMenu} size="large">
              <img
                src={getIconPath(applicationName)}
                alt={applicationName}
                style={{ width: 24, height: 24 }}
              />
            </IconButton>
          </Tooltip>

          <UtilityHeaderHelpMenu />
          <Tooltip
            title={
              <Stack spacing={0.5}>
                <Typography component="span" variant="body2">
                  {firstLast}
                </Typography>
                <Typography component="span" variant="caption">
                  {secondaryUserInfo}
                </Typography>
              </Stack>
            }
          >
            <IconButton
              analytics={['navigation', 'open-account-menu-intent', 'navigation:app-bar']}
              onClick={openUserMenu}
              aria-label="account"
              color="primary"
              size="large"
            >
              <Avatar
                src={`/frameworkapi/users/${currentUserId}/picture`}
                alt="Profile"
                sx={{ width: 24, height: 24 }}
              />
            </IconButton>
          </Tooltip>
        </Box>
      ) : (
        <IconButton
          analytics={['navigation', 'switch-apps', 'navigation:app-bar']}
          color="primary"
          aria-label="open user menu"
          onClick={openUserMenu}
          size="large"
        >
          <MoreVertIcon />
        </IconButton>
      )}
    </>
  );
};

export default UtilityBar;
